import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useContext } from "react";
import { useState } from "react";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import BackandLay from "./BackandLay";
import EmptyOdds from "./EmptyOdds";
import Keyboard from "./Keyboard";
import MarketHeader, { MarketLimits, MarketSeparator, marketRowStyles } from "./MarketHeader";

const Bookmaker = ({
  data,
  details,
  betType,
  back_odds,
  lay_odds,
  bookmakerObj,
  setSlipObj,
  slipObj,
  profileData,
  handelBookmakerPositions,
  resetSelection,
  user,
  messaageBox,
  bottomSpaceClass
}) => {
  let {
    handelPlaceBetfair,
    setBetFairObj,
    betSelectionObj,
    setBetSelectionObj,
  } = useContext(BetSlipContext);
  const { messagelist } = useContext(AuthProvider);
  const [popupMessage, setPopupMessage] = useState("");
  const [selectedBet, setSelectedBet] = useState({
    selectionId: "",
    teamName: "",
    check: "",
    sid: ""
  });
  const [key, setKey] = useState("");
  const [amountRange, setAmountRange] = useState({
    min: 0,
    max: 0,
    oddsLimit: 0,
    betDelay: 0
  });

  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) =>
        res?.type == "bookmaker"
    );
    if (!isEmpty(obj)) {
      setAmountRange({
        min: Number(obj?.minAmount) || 0,
        max: Number(obj?.maxAmount) || 0,
        oddsLimit: obj.oddsLimit ? obj.oddsLimit : 0,
        betDelay: obj?.betDelay
      });
    }
  }, [profileData]);

  return (
    <div id="bookMakerWrap" className={bottomSpaceClass} style={{ marginTop: 0 }}>
      <MarketSeparator />
      <div
        className={`bets-wrap bets-bookmaker ${details.bookMaker == "off"
          ? "disabled"
          : amountRange.oddsLimit == 0
            ? "disabled"
            : ""
          }`}
        style={{ display: "block" }}
      >
        <div style={{ position: "relative" }}>
          <MarketHeader
            name="Bookmaker"
            matched={bookmakerObj?.totalMatched == null ? undefined : Number(bookmakerObj.totalMatched).toLocaleString("en-US", { notation: "compact", maximumFractionDigits: 1 })}
            showMinMax={false}
            onInfo={() => setPopupMessage((open) => !open)}
          />
          {/* <p>| Zero Commission</p> */}
          {popupMessage && (
            <div
              id="bookMakerMinMax"
              style={{
                display: "flex",
                top: "100%",
                right: "0",
                zIndex: 10,
              }}
              className="fancy_info-popup"
            >
              <dl>
                <dt>Min / Max</dt>
                <dd id="minMax">
                  {" "}
                  {amountRange?.min?.toFixed(2)} /{" "}
                  {amountRange?.max?.toFixed(2)}
                </dd>
              </dl>
              <dl>
                <dt id="rebateName" style={{ display: "none" }}>
                  Rebate
                </dt>
                <dd id="rebate" style={{ display: "none" }}></dd>
              </dl>
              <a
                href="javascript:void(0)"
                onClick={() => setPopupMessage(false)}
                id="closeBookMakerInfo"
                className="close"
              >
                Close
              </a>
            </div>
          )}
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          minHeight: "26px",
          padding: "4px 8px",
          boxSizing: "border-box",
          background: "linear-gradient(90deg, #f8f6df, #dfe9f0)",
          overflow: "hidden",
        }}>
          <marquee direction="left" scrollamount="4" style={{ color: "#1a1a1a", fontSize: "12px", fontWeight: "700", margin: 0, fontFamily: "Tahoma, Helvetica, sans-serif" }}>
            {messagelist?.length > 0
              ? messagelist.map((res, i) => `${details?.eventName || ""} : ${res?.message}`).join("     \u2022     ")
              : `${details?.eventName || ""} : Advance Match Bet Started In Our Exchange \ud83c\udfcf`}
          </marquee>
        </div>
        <MarketLimits
          min={profileData?.matchSetting?.some((setting) => setting.type === "bookmaker") ? amountRange.min : bookmakerObj?.min}
          max={profileData?.matchSetting?.some((setting) => setting.type === "bookmaker") ? amountRange.max : bookmakerObj?.max}
          bookmaker
        />
        {data.map((res) => {
          const the_odds_back = back_odds;
          let filterOddsBack = the_odds_back
            ?.filter((todd) => todd.name == res.RunnerName)
            ?.sort((a, b) => {
              return a - b;
            });

          const the_odds_lay = lay_odds;
          const filterOddsLay = the_odds_lay
            ?.filter((todd) => todd.name == res.RunnerName)
            ?.sort((a, b) => {
              return a - b;
            });

          const marketUnavailable = bookmakerObj?.ms != null && Number(bookmakerObj.ms) !== 1;

          return (
            <React.Fragment key={res.SelectionId}>
              <dl className="market-selection-row" style={{ ...marketRowStyles.row, gridTemplateColumns: "minmax(0, 1fr) repeat(2, 17.5%)", background: "#faf9d9" }}>
                <dt style={marketRowStyles.selection}>
                  <h4 style={marketRowStyles.name}>{res.RunnerName}</h4>
                  <ul style={marketRowStyles.positions}>
                    {Math.abs(res.position) != 0 &&
                      !isNaN(Math.abs(res.position)) && (
                        <li
                          id="withBet"
                          class={res.position <= 0 ? "lose" : "win"}
                          style={{ display: "list-item" }}
                        >
                          {parseFloat(Math.abs(res.position)).toFixed(2)}
                        </li>
                      )}

                    {Math.abs(res.newPosition) != 0 &&
                      !isNaN(Math.abs(res.newPosition)) && (
                        <li
                          id="withBet"
                          class={res.newPosition <= 0 ? "to-lose" : "to-win"}
                          style={{ display: "list-item" }}
                        >
                          ( {parseFloat(Math.abs(res.newPosition)).toFixed(2)})
                        </li>
                      )}
                  </ul>

                  {/* {Math.abs(res?.position) != 0 &&
                    !isNaN(Math.abs(res?.position)) && (
                      <ul>
                        <li
                          id="before"
                          class="win"
                          style={{ display: "none" }}
                        ></li>
                        <li
                          id="after"
                          className={res?.position <= 0 ? "to-lose" : "to-win"}
                        >
                          ( {Math.abs(res?.position)?.toFixed(2)})
                        </li>
                      </ul>
                    )} */}
                </dt>
                {/* {bookmakerObj?.rt !== 1 ? (
                  <>
                    <dd id="suspend" class="suspend-fancy">
                      <p id="info">
                        {bookmakerObj?.ms == 9
                          ? "Ball Running"
                          : bookmakerObj?.ms == 2
                          ? "In Active"
                          : bookmakerObj?.ms == 3
                          ? "Suspended"
                          : bookmakerObj?.ms == 4
                          ? "Closed"
                          : ""}
                      </p>
                    </dd>
                    <EmptyOdds />
                  </>
                ) : !the_odds_lay.map((item) =>
                    item.ri == res.selectionID ? true : false
                  )[0] ||
                  !the_odds_back.map((item) =>
                    item.ri == res.selectionID ? true : false
                  )[0] ? (
                  <>
                    <dd id="suspend" class="suspend-fancy">
                      <p id="info">Suspended</p>
                    </dd>
                    <EmptyOdds />
                  </>
                ) : ( */}
                {details?.sport_setting?.status == "inActive" || marketUnavailable ? (
                  <>
                    <dd className="suspend-fancy" style={{ ...marketRowStyles.suspension, width: "35%" }}>
                      <p style={{ margin: 0, padding: 0, lineHeight: 1.2 }}>Suspended</p>
                    </dd>
                    <EmptyOdds compact />
                  </>
                ) : (
                  <>
                    {/* Only show status label when we have actual ms data indicating non-active state */}
                    {(filterOddsBack[0]?.ms != null && Number(filterOddsBack[0].ms) !== 1) || (filterOddsLay[0]?.ms != null && Number(filterOddsLay[0].ms) !== 1) ? (
                      <dd className="suspend-fancy" style={{ ...marketRowStyles.suspension, width: "35%" }}>
                        <p style={{ margin: 0, padding: 0, lineHeight: 1.2 }}>
                          {filterOddsBack[0]?.ms == 9 || filterOddsLay[0]?.ms == 9
                            ? "Ball Running"
                            : filterOddsBack[0]?.ms == 2 || filterOddsLay[0]?.ms == 2
                              ? "In Active"
                              : filterOddsBack[0]?.ms == 3 || filterOddsLay[0]?.ms == 3
                                ? "Suspended"
                                : filterOddsBack[0]?.ms == 4 || filterOddsLay[0]?.ms == 4
                                  ? "Closed"
                                  : "Suspended"}
                        </p>
                      </dd>
                    ) : ""}

                    {isEmpty(bookmakerObj) ? (
                      <>
                        <EmptyOdds compact />
                      </>
                    ) : (
                      <BackandLay
                        compact
                        back={filterOddsBack || []}
                        lay={filterOddsLay || []}
                        setSelectedBet={setSelectedBet}
                        item={res}
                        setKey={setKey}
                        market={""}
                        messaageBox={messaageBox}
                        betmode={marketUnavailable ? "off" : details.bookMaker}
                        setSlipObj={setSlipObj}
                        resetSelection={resetSelection}
                        details={details}
                        slipObj={slipObj}
                        handelBookmakerPositions={handelBookmakerPositions}
                        amountRange={amountRange}
                        // setCondi={setCondi}
                        // handelBetFairPositions={handelBetFairPositions}
                        // executeScroll={executeScroll}
                        betType={betType}
                        bookmakerObj={bookmakerObj}
                      />
                    )}
                  </>
                )}
              </dl>
              {betSelectionObj?.priceToogle &&
                betSelectionObj?.priceToogleType == "odds" &&
                key == res.SelectionId &&
                betSelectionObj?.betType == "bookmaker" ? (
                <Keyboard
                  // tempSelection={tempSelection}
                  // setSelections={setSelections}
                  details={details}
                  betType={betType}
                  selectedBet={selectedBet}
                  setSlipObj={setSlipObj}
                  resetSelection={resetSelection}
                  // resetSelection={resetSelection}
                  handelPlaceBetfair={handelPlaceBetfair}
                  amountRange={amountRange}
                />
              ) : (
                ""
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default Bookmaker;
